module.exports = __webpack_public_path__ + "r-v3/img/ml_07_00_over.f8328e15.jpg";